var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.6431C18.1541 23.6431 23.1429 18.6543 23.1429 12.5003C23.1429 6.34625 18.1541 1.35742 12 1.35742C5.84601 1.35742 0.857178 6.34625 0.857178 12.5003C0.857178 18.6543 5.84601 23.6431 12 23.6431Z",
    stroke: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5V18.5",
    stroke: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.07171C12.4735 9.07171 12.8572 8.68795 12.8572 8.21457C12.8572 7.74118 12.4735 7.35742 12.0001 7.35742C11.5267 7.35742 11.1429 7.74118 11.1429 8.21457C11.1429 8.68795 11.5267 9.07171 12.0001 9.07171Z",
    stroke: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.182f641883c5551175e545d08edee2ba.svg";
export { ForwardRef as ReactComponent };